export default __webpack_public_path__ + "static/media/Cakemania_1896x983.3d55095d.png";